exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.discount[data-v-6e233336]{width:100%;height:250px;background-position:center;background-size:cover;cursor:pointer\n}\n.discount .discount-content[data-v-6e233336]{width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;color:#fff;padding:10px;background-color:rgba(0,0,0,0.6)\n}\n.discount .discount-content span[data-v-6e233336]{font-size:0.9rem\n}\n", ""]);

// exports
